import { BaseBonusBoardDrawer } from './BaseBonusBoardDrawer';
import { mobileConfig } from '../../../core/applicationConfig';
import {
  BONUS_TOTAL_ODD,
  BONUS_WIN_STATE,
  FREE_SPIN_COUNT_STATE,
  MULTIPLIER_STATE,
  TOTAL_WIN_STATE,
} from '../../../stateManagment';

export class BonusBoardMobileDrawer extends BaseBonusBoardDrawer {
  constructor() {
    super();
    this.config = {
      space: 220,
      top: 1150,
      spaceTop: 150,
    };
  }

  setMultiplier() {
    const [content, onSet] = this.getMultiplier({ scale: .8 });
    this.setPosition(content, { x: mobileConfig.width - this.config.space, y: this.config.top });
    this.addSubscriber(MULTIPLIER_STATE.subscribe(onSet, true));
    this.container.addChild(content);
  }

  setFreeSpin() {
    const [content, onSet] = this.getFreeSpin({ scale: .8 });
    this.setPosition(content, { x: this.config.space, y: this.config.top });
    this.addSubscriber(FREE_SPIN_COUNT_STATE.subscribe(onSet, true));
    this.container.addChild(content);
  }

  setTotalWin() {
    const [content, onSetOdd, onSetWin] = this.getTotalWin({
      scale: 1.4,
      containerScale: 1.1,
      fontSize: 30,
      multiplierPosition: { x: 156, y: 808 },
    });
    this.setPosition(content, { x: mobileConfig.width / 2, y: this.config.spaceTop });
    this.addSubscriber(BONUS_TOTAL_ODD.subscribe(onSetOdd, true));
    this.addSubscriber(BONUS_WIN_STATE.subscribe(onSetWin, true));
    this.container.addChild(content);
  }

  execute() {
    this.setMultiplier();
    this.setFreeSpin();
    this.setTotalWin();
  }
}